var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import AccurityIcon from '../../icon/components/AccurityIcon';
import Stack from '@mui/material/Stack';
var AddRemoveButton = function (_a) {
    var _b = _a.add, add = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, rest = __rest(_a, ["add", "disabled", "onClick"]);
    return (React.createElement(Tooltip, { title: disabled ? 'Disabled' : '' },
        React.createElement(Stack, { justifyContent: "center", alignItems: "center", sx: {
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                backgroundColor: function (theme) { return theme.palette.secondary300.main; },
                color: function (theme) { return disabled ? theme.palette.disabled.main : theme.palette.secondary700.main; },
                '&:hover': {
                    color: function (theme) { return disabled ? theme.palette.disabled.main : theme.palette.light.main; },
                    backgroundColor: function (theme) { return disabled ? undefined : theme.palette.primary.main; },
                },
                cursor: disabled ? undefined : 'pointer',
            } },
            React.createElement(AccurityIcon, __assign({ iconName: add ? 'mui:Add' : 'mui:Remove' }, rest, { onClick: (!disabled && onClick) ? onClick : undefined })))));
};
export default AddRemoveButton;
//# sourceMappingURL=AddRemoveButton.js.map